import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import {
  // useRouter,
  type RouteRecordRaw
} from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'

// import { useBookmarkStore } from './store/modules/bookmark'
// import { getMenuByRole } from './api/login'

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

// const extractPath = (path) => {
//   const parts = path.split('/')
//   return parts[parts.length - 1]
// }

// const updateLeafNodeNames = (routes) => {
//   // Helper function to check if a route is a leaf node
//   function isLeafNode(route) {
//     return !route.children || route.children.length === 0
//   }

//   // Helper function to update the name of a leaf node
//   function updateName(route) {
//     return {
//       ...route,
//       name: extractPath(route.component)
//     }
//   }

//   // Recursive function to process the routes
//   function processRoutes(routes) {
//     return routes.map((route) => {
//       if (isLeafNode(route)) {
//         return updateName(route)
//       } else {
//         return {
//           ...route,
//           children: processRoutes(route.children)
//         }
//       }
//     })
//   }
//   return processRoutes(routes)
// }

router.beforeEach(async (to, from, next) => {
  start()
  loadStart()
  const permissionStore = usePermissionStoreWithOut()
  const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()
  // const bookmarkStore = useBookmarkStore()
  // const { addRoute } = useRouter()

  // Get role information
  // const getRole = async () => {
  //   const res = await getMenuByRole()

  //   if (res) {
  //     const routers = updateLeafNodeNames(res.data) || []
  //     userStore.setRoleRouters(routers)
  //     appStore.getDynamicRouter && appStore.getServerDynamicRouter
  //       ? await permissionStore.generateRoutes('server', routers).catch(() => {})
  //       : await permissionStore.generateRoutes('frontEnd', routers).catch(() => {})

  //     permissionStore.getAddRouters.forEach((route) => {
  //       addRoute(route as RouteRecordRaw)
  //     })

  //     next({ path: to.path })
  //   } else {
  //     next()
  //   }
  // }

  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (permissionStore.getIsAddRouters) {
        next()
        return
      }

      // Developers can modify it according to the actual situation
      const roleRouters = userStore.getRoleRouters || []

      // Whether to use dynamic routing
      if (appStore.getDynamicRouter) {
        appStore.serverDynamicRouter
          ? await permissionStore.generateRoutes('server', roleRouters as AppCustomRouteRecordRaw[])
          : await permissionStore.generateRoutes('frontEnd', roleRouters as string[])
      } else {
        await permissionStore.generateRoutes('static')
      }

      permissionStore.getAddRouters.forEach((route) => {
        router.addRoute(route as unknown as RouteRecordRaw) // Dynamic adding accessable routing table
      })
      const redirectPath = from.query.redirect || to.path
      const redirect = decodeURIComponent(redirectPath as string)
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      permissionStore.setIsAddRouters(true)
      next(nextData)
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // Otherwise, all redirect to the login page
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // End Progress
  loadDone()
})
